'use client'

import { useId, useState } from 'react'
import cn from 'classnames'
import styles from './index.module.scss'

type TextFieldProps = {
  label: string
  value: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void

  type?: React.HTMLInputTypeAttribute
  className?: string
  disabled?: boolean
  hasError?: boolean

  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void
  onPaste?: (event: React.ClipboardEvent<HTMLInputElement>) => void

  name?: string
  placeholder?: string
  autoComplete?: string
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode']
}

export default function TextField({
  label,
  value,
  onChange,
  type = 'text',
  className,
  disabled = false,
  hasError = false,
  onBlur,
  onFocus,
  onPaste,
  name,
  placeholder,
  autoComplete,
  inputMode,
}: TextFieldProps) {
  const id = useId()
  const [isFocused, setIsFocused] = useState(false)

  const isSelected = isFocused || value.length > 0

  return (
    <div
      className={cn(
        styles.field,
        className,
        disabled && styles.disabled,
        isSelected && styles.selected,
        hasError && styles.error,
      )}
    >
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>

      <input
        id={id}
        name={name}
        type={type}
        className={styles.input}
        disabled={disabled}
        value={value}
        placeholder={placeholder}
        autoComplete={autoComplete}
        inputMode={inputMode}
        aria-invalid={hasError || undefined}
        onChange={onChange}
        onPaste={onPaste}
        onFocus={(e) => {
          setIsFocused(true)
          onFocus?.(e)
        }}
        onBlur={(e) => {
          setIsFocused(false)
          onBlur?.(e)
        }}
      />
    </div>
  )
}
